module.exports = new __parcel__URL__("candy.ffd5e59f.svg").toString();